import { render } from "./HookOption.vue?vue&type=template&id=9aa6445c&scoped=true"
import script from "./HookOption.vue?vue&type=script&lang=js"
export * from "./HookOption.vue?vue&type=script&lang=js"

import "./HookOption.vue?vue&type=style&index=0&id=9aa6445c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa6445c"]])

export default __exports__